module.exports = __webpack_public_path__ + "img/Half-Orc-Paladin.e222aa75.png";